import { createAxios } from '../lib/axiosFactory';
import { errorParser } from '../lib/response/errorParser';

export const actions = {
  async createListAssignments(
    context: any,
    { payload, mode, listIds, searchTerm, fromListId }
  ) {
    try {
      const response = await createAxios().post(
        `/backend/bulk-list-assignments-create`,
        {
          data: payload
        },
        {
          params: {
            mode: mode,
            listIds: listIds,
            ...(fromListId && {
              'filter[listIds][val]': fromListId,
              'filter[listIds][op]': 'arrayContains'
            }),
            ...(searchTerm && {
              'filter[__search:first_name,last_name,phone][val]': searchTerm,
              'filter[__search:first_name,last_name,phone][op]': 'search'
            })
          }
        }
      );

      return {
        success: true,
        errors: {},
        body: response.data,
        status: response.status
      };
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error.response.data
      };
    }
  },

  async removeListAssignments(
    context: any,
    { payload, mode, listId, searchTerm }
  ) {
    try {
      const response = await createAxios().patch(
        '/backend/bulk-list-assignments-delete',
        {
          data: payload
        },
        {
          params: {
            clientId: context.rootState.user.clientId,
            mode,
            listId,
            'filter[listIds][val]': listId,
            'filter[listIds][op]': 'arrayContains',
            ...(searchTerm && {
              'filter[__search:first_name,last_name,phone][val]': searchTerm,
              'filter[__search:first_name,last_name,phone][op]': 'search'
            })
          }
        }
      );

      return {
        success: true,
        errors: {},
        body: response.data,
        status: response.status
      };
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error.response.data
      };
    }
  }
};
